import { render, staticRenderFns } from "./BellVideo.vue?vue&type=template&id=2545c6c8&scoped=true&"
import script from "./BellVideo.vue?vue&type=script&lang=js&"
export * from "./BellVideo.vue?vue&type=script&lang=js&"
import style0 from "./BellVideo.vue?vue&type=style&index=0&id=2545c6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545c6c8",
  null
  
)

export default component.exports